import { useEffect, useState, useContext } from 'react';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { Typography, Button, FormControlLabel, Checkbox } from '@mui/material';
// Our Components
import { AuthContext } from 'context/auth-context';
// Services
import { Users } from 'lib/api';
// Utils and Helpers
import { EULAS } from 'helpers/constants';
// Assets
import { ReactComponent as CardDouble } from 'assets/modalKYX/Card_double.svg';
import { ReactComponent as InfoIcon } from 'assets/modalKYX/InfoIconBlack.svg';

const useStyles = makeStyles({
    banner: {
        backgroundColor: '#182D55 !important',
        maxWidth: '16em',
        minHeight: '100%',
        paddingTop: '3em',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px'
    },
    dialogBody: {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '600px',
        height: '100%'
    },
    bannerTitle: {
        color: 'white',
        fontWeight: '700!important'
    },
    bannerSpan: {
        color: 'white'
    },
    bannerText: {
        margin: '1em'
    },
    dialogContent: {
        backgroundColor: 'transparent!important',
        padding: '0!important',
        minHeight: '600px',
        minWidth: '64em'
    },
    content: {
        margin: '2em',
        width: '40em'
    },
    contentTitle: {
        fontWeight: '700!important'
    },
    verifyOption: {
        borderRadius: '15px',
        border: '1px solid #d4d4d4',
        padding: '2em 1em',
        display: 'flex',
        flexDirection: 'row',
        paddingRight: '36px',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    verifyText: {
        maxWidth: '30em'
    },
    verifyTitle: {
        fontWeight: '700!important'
    },
    startKYX: {
        color: 'white!important',
        borderRadius: '25px!important',
        marginLeft: '1em',
        padding: '.5em 1em!important'
    },
    doItLater: {
        marginTop: '10em'
    },
    anchorHere: {
        color: '#1BAAE2',
        textDecoration: 'none'
    }
});

export const KYXEulaSecondStep = ({ handleChange }) => {
    const classes = useStyles();

    const { userInfo } = useContext(AuthContext);

    const [linkClicked, setLinkClicked] = useState(false);
    const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleAccept = async () => {
        if (isChecked) {
            await Users.updateLastEULA(userInfo.id, EULAS.END_USER_LEGAL_AGREEMENTS);
            handleChange(7);
        }
    };

    useEffect(() => {
        if (linkClicked) {
            setIsCheckboxEnabled(true);
        }
    }, [linkClicked]);

    return (
        <Box className={classes.dialogBody}>
            <Box
                className={classes.banner}
                sx={{
                    display: { lg: 'initial', md: 'initial', sm: 'none', xs: 'none' }
                }}>
                <CardDouble />
                <Box className={classes.bannerText}>
                    <Typography variant="h5" component="h5" className={classes.bannerTitle}>
                        Welcome to the Paystand DeFi Corporate Card!
                    </Typography>
                    <Typography className={classes.bannerSpan}>
                        Manage all of your expenses with virtual cards that work exactly like credit cards, and give you reward
                        points in bitcoin.
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.content}>
                <Typography variant="h6" className={classes.contentTitle}>
                    End-User Legal Agreements
                </Typography>
                <Box>
                    <Box
                        style={{
                            maxHeight: '300px',
                            marginTop: '20px',
                            marginBottom: '15px',
                            fontSize: '13px',
                            padding: '15px',
                            fontWeight: '500',
                            color: '#182D55',
                            border: '1px solid #DFE3E6',
                            borderRadius: '5px'
                        }}>
                        <p>
                            Click{' '}
                            <a
                                href="https://www.paystand.com/defi-card-terms-of-service?hs_preview=GWOMCJDX-57922621962"
                                target="_blank"
                                className={classes.anchorHere}
                                onClick={() => setLinkClicked(true)}>
                                here
                            </a>{' '}
                            to review:
                            <ul>
                                <li>Lewis & Clark Bank Business Account And Cardholder Agreement</li>
                                <li>Terms & Conditions of Paystand and Solid</li>
                                <li>Privacy Policies of Paystand, Solid, and Lewis and Clark Bank</li>
                            </ul>
                        </p>
                    </Box>
                    <Box
                        style={{
                            maxHeight: '300px',
                            marginTop: '20px',
                            marginBottom: '15px',
                            backgroundColor: '#F6F7F7',
                            fontSize: '13px',
                            padding: '10px',
                            fontWeight: '500',
                            color: '#182D55',
                            borderRadius: '5px'
                        }}>
                        <InfoIcon
                            style={{
                                color: 'black',
                                marginRight: '5px',
                                marginBottom: '-3px'
                            }}
                        />
                        Please click on the link above and review the End User Legal Agreements to continue.
                    </Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isChecked}
                                disabled={!isCheckboxEnabled}
                                onChange={() => setIsChecked(!isChecked)}
                            />
                        }
                        label="I have read and agree to the Lewis & Clark Bank Business Account And Cardholder Agreement, Terms & Conditions, and Privacy Policy"
                    />
                    <Box sx={{ mt: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAccept}
                            disabled={!isChecked}
                            sx={{ marginTop: '150px' }}>
                            Next
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};
